enum PostingSources {
  MARKETPLACE = "Marketplace",
  COMPANIES = "Companies",
}
export default PostingSources;
